import React, { useEffect } from 'react';
import '../../styles/Projekt.css';
import { Link } from 'react-router-dom';

class Kereszt extends React.Component {
    render() {
        return (
            <img src={process.env.PUBLIC_URL + '/assets/kereszt.png'} alt="kereszt" className='kereszt-icon' />
        );
    }
}

function Projekt() {

    // Preload the kereszt image to prevent flickering
    useEffect(() => {
        const img = new Image();
        img.src = process.env.PUBLIC_URL + '/assets/kereszt.png';
    }, []);

    const listItems = [
        "céljaink, tevékenységünk",
        "a projekt története képekkel és filmekkel",
        "a Mohács-500 emlékévhez kapcsolódó programjaink",
        "T.é.r. (Történelmi életmód rekonstrukciós) segédlet a naszádosok megjelenítéséhez",
        "a hajókról"
    ];



    return (
        <>
        {/* col-xl-4 offset-xl-2 offset-xxl-2 */}
            <div className='projekt-container'>
                <div className='listItem-container'>
                {listItems.map((item, index) => (
                    <div className='projekt-text-container' key={index}>
                        <Kereszt />
                        <Link to={
                            index === 0 ? '/celjaink' :
                            index === 1 ? '/projekt-tortenet' : 
                            index === 2 ? '/mohacs-500' :
                            index === 3 ? '/ter-segedlet' :
                            index === 4 ? '/hajokrol' :
                            index === 5 ? '' : ''
                        } className='projekt-list-item h2' >{item}</Link>
                    </div>
                ))}
                </div>
            </div>
        </>
    );
}

export default Projekt;
